import { useWatch } from 'react-hook-form';
import { FormField } from 'v5/design-system/Form';
import { useFieldContext } from '../FieldContext';
import { EmptyField } from './EmptyField';
import { FieldControlBase } from './FieldControlBase';
import type {
  FieldFrameSpec,
  FieldPartProps,
  PlaceholderSpec
} from './fieldComponent.types';
import { NumberInput } from './numberInput';

/** Numeric input over `number | null` (legacy `NUMBER.jsx`); empty is `null`. */
export function NumberField({
  spec,
  path,
  hideLabel
}: FieldPartProps<FieldFrameSpec & PlaceholderSpec>) {
  const ctx = useFieldContext();
  const readOnly = ctx.mode === 'display';
  const number: number | null = useWatch({ name: path }) ?? null;

  if (readOnly && number === null) {
    return <EmptyField spec={spec} path={path} hideLabel={hideLabel} />;
  }

  return (
    <FormField
      name={path}
      render={({ field }) => (
        <FieldControlBase spec={spec} hideLabel={hideLabel}>
          <NumberInput
            readOnly={readOnly}
            variant={ctx.variant}
            size={ctx.size}
            placeholder={
              spec.placeholder ?? `Enter ${spec.label.toLowerCase()}`
            }
            {...field}
          />
        </FieldControlBase>
      )}
    />
  );
}
